import { __assign } from "tslib";
import React, { useCallback } from "react";
import { IconButton, InputAdornment } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Search as SearchIcon } from "@material-ui/icons";
import debounce from "lodash/debounce";
import { SearchBar } from "../Table/styles";
var SearchBarComponent = function (_a) {
    var inputValue = _a.inputValue, setInputValue = _a.setInputValue, placeHolder = _a.placeHolder, _b = _a.isDebounced, isDebounced = _b === void 0 ? true : _b, _c = _a.debounceTime, debounceTime = _c === void 0 ? 500 : _c, onChange = _a.onChange, width = _a.width, customStyles = _a.customStyles, _d = _a.disabled, disabled = _d === void 0 ? false : _d, searchInputCustomStyles = _a.searchInputCustomStyles;
    var theme = useTheme();
    var debouncedSearch = useCallback(debounce(function (searchText) {
        onChange(searchText);
    }, debounceTime), []);
    return (React.createElement(SearchBar, { "$customStyles": customStyles, hiddenLabel: true, InputProps: {
            autoFocus: true,
            style: __assign({ color: theme.palette.text.primary, backgroundColor: theme.palette.background.paper }, searchInputCustomStyles),
            disableUnderline: true,
            startAdornment: (React.createElement(InputAdornment, { position: "start" },
                React.createElement(IconButton, { size: "small", disabled: disabled },
                    React.createElement(SearchIcon, { style: { color: "hsl(223,10%,58%)" }, height: 20, width: 20 }))))
        }, color: "primary", onChange: function (_a) {
            var value = _a.target.value;
            setInputValue(value);
            if (isDebounced) {
                debouncedSearch(value);
            }
            else {
                onChange(value);
            }
        }, variant: "filled", size: "small", placeholder: placeHolder, value: inputValue, width: width, disabled: disabled }));
};
export default SearchBarComponent;
//# sourceMappingURL=index.js.map